import React from "react";

export const SegmentSelect = (props) => {
    const {selectedSegment, onSelectSegment, segmentOptions, disabled} = props;

    const handleSegmentChange = (event) => {
        const segment = event.target.value;
        onSelectSegment(segment);
    };

    return (
        <div className="filter-group">
            <div className="filter-group-content">
                <div className="input-container">
                    <span className="static-text">Segment: </span>
                    <div className="form-select" style={{margin: '6px 0px'}}>
                        <select value={selectedSegment ? selectedSegment : ""}
                                onChange={handleSegmentChange}
                                className="form-select"
                                disabled={disabled}
                        >
                            <option
                                className="select-placeholder"
                                value=""
                                defaultValue
                                disabled
                            >
                                Please select an option
                            </option>
                            {segmentOptions && segmentOptions.map((segment) => (
                                <option key={segment.segmentName} value={segment.segmentName}>{segment.segmentName}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    )
}
